export default __webpack_public_path__ + "static/media/ShellyNoBackground.2af015f1.png";